<template>
    <div class="section">
        <!-- 多平台下载 -->
        <div class="download text-center" ref="platform">
            <div class="left">
                <a :href="android" class="text-warning">Android</a>
            </div>
            <div class="right">
<!--                <a :href="'itms-services://?action=download-manifest&url=https://admin.e-letao.com/download/ios.plist'" class="text-warning">IOS</a>-->
                <a :href="ios" class="text-warning">IOS</a>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
// import VueAwesomeSwiper from "vue-awesome-swiper";
import vueQr from "vue-qr";
import Home from "@/api/home";
// import "swiper/swiper-bundle.css";
import Socket from "@/api/server/Socket.js";
import College from "@/api/college";
import Member from "@/api/member";
// Vue.use(VueAwesomeSwiper);
export default {
  components: {
    vueQr,
  },

  computed: {
    isLogin() {
      return Boolean(localStorage.token);
    },
  },
  data() {
    return {
      android: "",
        ios: ""
    };
  },
  methods: {
      downloadLink() {
          Home.getNewestVersion().then((res) => {
              // console.log(res);
              this.android = res.android.url;
              this.ios = res.ios.url;
          }).catch((err) => {});
      },
  },
  mounted() {
      if (this.isLogin) {

      }

      this.downloadLink();
  },
};
</script>

<style lang="scss" scoped>
.download{
   display: block;
    margin: auto;
    font-size: 0;
    .left, .right {
        width: 50%;
        font-size: calc(100vw * 14/375);
        display: inline-block;
        padding: 1vw 1vw;
    }
    .left {
        text-align: right;
    }
    .right {
        text-align: left;
    }
    a {
        display: inline-block;
        padding: 2vw 2vw;
        background: gray;
        border-radius: 1vw;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/download/index.vue